export default __webpack_public_path__ + "static/media/mistake_ex_3@2x.7f58867a.png";